import { setupVariableGroup } from "./helpers";
export const ensureThemeStyleVariableGroup = (store)=>{
    const group = `theme`;
    const theme = [
        {
            name: "font",
            modes: {
                default: {
                    value: {
                        type: "css-font",
                        value: "System Font",
                        style: "normal",
                        kind: "system",
                        weight: "normal"
                    }
                }
            }
        }
    ];
    // @ts-ignore
    setupVariableGroup(store, {
        group,
        variables: theme
    });
// const postfixes = [
//   "color.primary.light",
//   "color.primary.dark",
//   "color.secondary.light",
//   "color.secondary.dark",
// ];
// postfixes.forEach((postfix) => {
//   const colorStyle = SWStateRecordType.createId(`style.${postfix}`);
//   if (!store.has(colorStyle)) {
//     store.put([
//       SWStateRecordType.create({
//         id: colorStyle,
//         defaultValue: {
//           type: "css-color",
//           value: colorStyle.includes("light") ? "#FF0000" : "#00FF00",
//         },
//       }),
//     ]);
//   }
// });
// const backgroundColorStyleLight = SWStateRecordType.createId(
//   `style.color.background.light`
// );
// if (!store.has(backgroundColorStyleLight)) {
//   store.put([
//     SWStateRecordType.create({
//       id: backgroundColorStyleLight,
//       defaultValue: {
//         type: "css-color",
//         value: "#FFFFFF",
//       },
//     }),
//   ]);
// }
// const backgroundColorStyleDark = SWStateRecordType.createId(
//   `style.color.background.dark`
// );
// if (!store.has(backgroundColorStyleDark)) {
//   store.put([
//     SWStateRecordType.create({
//       id: backgroundColorStyleDark,
//       defaultValue: {
//         type: "css-color",
//         value: "#000000",
//       },
//     }),
//   ]);
// }
// const deviceInterfaceStyle = SWStateRecordType.createId(
//   "device.interfaceStyle"
// );
// if (!store.has(deviceInterfaceStyle)) {
//   store.put([
//     SWStateRecordType.create({
//       id: deviceInterfaceStyle,
//       defaultValue: {
//         type: "string",
//         value: "light",
//       },
//       derivation: {
//         message:
//           "This is set based on whether the device is in light or dark mode.",
//         derivation: "deviceInterfaceStyle",
//       },
//     }),
//   ]);
// }
// const colorStyleVariableGroup =
//   SWStyleVariableGroupRecordType.createId("color");
// if (!store.has(colorStyleVariableGroup)) {
//   store.put([
//     SWStyleVariableGroupRecordType.create({
//       id: colorStyleVariableGroup,
//       index: "a1",
//       group: {
//         controlledBy: {
//           type: "state",
//           stateId: createStateId("device.interfaceStyle"),
//         },
//       },
//     }),
//   ]);
// }
// // Create the modes & variables
// const modes = ["light", "dark"];
// const secondIndex = getIndexAbove("a1")!;
// const indexes = ["a1", getIndexAbove("a1")!, getIndexAbove(secondIndex)!];
// modes.forEach((mode, index) => {
//   const modeStyleVariableGroup = SWStyleVariableGroupRecordType.createId(
//     `color.mode.${mode}`
//   );
//   if (!store.has(modeStyleVariableGroup)) {
//     store.put([
//       SWStyleVariableGroupRecordType.create({
//         id: modeStyleVariableGroup,
//         index: indexes[index],
//       }),
//     ]);
//   }
// });
// const variables = ["primary", "secondary", "background"];
// variables.forEach((variable, index) => {
//   const variableStyleVariableGroup = SWStyleVariableGroupRecordType.createId(
//     `color.variable.${variable}`
//   );
//   if (!store.has(variableStyleVariableGroup)) {
//     store.put([
//       SWStyleVariableGroupRecordType.create({
//         id: variableStyleVariableGroup,
//         index: indexes[index],
//       }),
//     ]);
//   }
// });
};
